import SceButton from '../../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from '../../twoFactorAuthenticationStrings';
import classes from '../../twoFactorAuthContainer.scss';
import RadioButton from '../../Common/ReactRadioGroup';
import TwoFactorAuthCodeTextBox from '../../Common/twoFactorAuthCodeTextBox';

function PhoneStepTwo(props) {
    let strings = getLocalizedStrings('twoFactorAuthenticationStrings');
    let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    const resendVerification = props.resendExceedMsg ?
        <div className={["sce-space-s", 'sce-center-alg'].join(" ")}><a className={classes.disabledSendCode}> {strings.resendCode}</a> <br />
            <span><img src={warningImg} alt="Warning Image" /></span>
            <span className={classes.errMsg}> {props.resendExceedMsg}</span>
        </div>
        :
        <div className={["sce-space-s", 'sce-center-alg',classes.centeraligned].join(" ")}> <a className={classes.sendCode}   href="JavaScript:void(0)" onClick={props.resendCodeHandler}> {strings.resendCode}</a></div>;
    const invalidCodeErrormsg = props.invalidCodeError ?
        <div className={"sce-space-s"}>
            <div className={classes.errorContainer}>
                <div> <img src={warningImg} alt="Warning Image" /> </div>
                <div className={["sce-caret", classes.errMsg].join(" ")}>
                    {strings.invalidVerifyCode}
                </div>
            </div>
        </div>
        : null;
    const tryAgain = !props.resendSuccess ?
        <div className={"sce-space-s"}>
            <div className={classes.errorContainer}>
                <div> <img src={warningImg} alt="Warning Image" /> </div>
                <div className={["sce-caret", classes.errMsg].join(" ")}>
                    {strings.tryAgain}
                </div>
            </div>
        </div>
        : null;
    const radioButton = props.changeFlag !== 'U' ? <div className={[classes.phoneTypes, "sce-space-s"].join(" ")}> {strings.phonetype}
        <div className={classes.radioButtonLeftMargin}>
            <RadioButton setName={'phoneType'} options={props.phoneType.labels}
                type='radio' validStyle={props.phoneType.validStyle} radioOutLineFlag={props.phoneType.outlineStyle}
                selectedOptions={props.phoneType.value} onClick={props.phoneTypeHandler}
            />
        </div>
    </div>
        : null;
    return (
        <div className={props.changeFlag !== 'U' ? classes.stepTwo: classes.emailStepTwo}>   
        <div className={classes.enterVerifyCode}>
            <div className={[classes.verifyLogIn, classes.verifyBtnFlex, 'sce-center-alg', "sce-space-s"].join(" ")}> {strings.enterVerificationCode}
                <div className={[classes.verifyAddress, "sce-space-s", "sce-space-s"].join(" ")}> {props.userEnteredValue}
                </div>
            </div>
            <div className={[classes.subTextCodeReceived, "sce-space-s"].join(" ")}> {props.typeOfAuth === "call" ? strings.enterVerificationCodeReceivedLandline : strings.enterVerificationCodeReceived}
                <div className={[classes.verificationCode, "sce-space-s"].join(" ")}> {strings.verificationCode}
                    <div>
                        <TwoFactorAuthCodeTextBox
                            type={props.typeOfAuth === "call" ? "verificationCode" : "verificationCodeSms"}
                            id={'verificationCode'}
                            validator={app.appUtil.validator}
                            maxLength={props.typeOfAuth === "call" ? props.callPinLength : props.textEmailPinLength}
                            onChangeVerifyHandler={props.onChangeHandler}
                        />
                    </div>
                    {invalidCodeErrormsg}
                    {radioButton}
                    <div className={["sce-space-s", 'sce-center-alg', classes.verifyBtn].join(" ")}>
                        <SceButton id='VerfiyCode' isDisabled={(props.disableVerifyBtn) ? true : false}
                            buttonType={(props.disableVerifyBtn) ? 'sceDisabled' : 'primary'}
                            value={strings.verify} onClick={props.verifyCodeHandler}
                        />
                    </div>
                    {resendVerification}
                    {tryAgain}
                </div>
            </div>
        </div>
        </div>
    );
}

export default PhoneStepTwo;